import { createSlice } from '@reduxjs/toolkit';
//import cloneDeep from 'lodash/cloneDeep';

import { apiOperation, padZeros } from '@/app/api/common';

export interface AppDescriptor {
  platform:			string;
  id:				string;
  name:				string;
  logo:				string;
  install_id:		string;
}

export interface AppsHolder {
  apps:				AppDescriptor[];
}

export const appsUrl = "/apps.json";

const initialState: AppsHolder = {
  apps:			[],
}

export const appsSlice = createSlice({
  name: 'apps',
  initialState,
  reducers: {
    assign: (state, action) => {
      state.apps = action.payload.apps;
    },
    setApps: (state, action) => {
      state.apps = action.payload;
    },
  },
});

export function copyAppDescriptor(desc: AppDescriptor): AppDescriptor {
  return {
    platform:			desc.platform,
    id:					desc.id,
    name:				desc.name,
    logo:				desc.logo,
    install_id:			desc.install_id,
  };
}

export function copyAppDescriptors(descs: AppDescriptor[]): AppDescriptor[] {
  if (!descs)
    return [];
  
  return descs.map((desc: AppDescriptor) => copyAppDescriptor(desc));
}

export function copyAppsHolder(holder: AppsHolder): AppsHolder {
  return {
    apps:				copyAppDescriptors(holder.apps),
  };
}

export function getNewAppDescriptor(): AppDescriptor {
  return {
    platform:			"",
    id:					"",
    name:				"",
    logo:				"",
    install_id:			"",
  };
}




